import { Routes, Route } from "react-router-dom";
import AuthGate from "./components/AuthGate";
import About from "./components/About";
import Dashboard from "./components/Dashboard";
import DeploymentView from "./components/DeploymentView";
import RuleAuthor from "./components/RuleAuthor";
import Evidence from "./components/manifold/Evidence";
import ErrorBoundary from "./components/ErrorBoundary";
import EnvironmentViewer from "./components/EnvironmentViewer";
import Landing from "./components/Landing";
import Login from "./components/Login";
import ProjectView from "./components/ProjectView";
import ScanUploader from "./components/ScanUploader";
import Sidebar from "./components/Sidebar";
import TrainingManager from "./components/TrainingManager";
import AgedCare from "./components/marketing/AgedCare";
import Compliance from "./components/marketing/Compliance";
import Contact from "./components/marketing/Contact";
import Essentials from "./components/marketing/Essentials";
import HowItWorks from "./components/marketing/HowItWorks";
import Maternal from "./components/marketing/Maternal";
import NightShift from "./components/marketing/NightShift";
import RoboTwins from "./components/marketing/RoboTwins";
import ProductEdgeReflex from "./components/marketing/ProductEdgeReflex";
import ProductIntelligenceCore from "./components/marketing/ProductIntelligenceCore";
import ProductLocalMind from "./components/marketing/ProductLocalMind";
import ProductScanToSim from "./components/marketing/ProductScanToSim";
import Signup from "./components/marketing/Signup";
import EdgeOverview from "./components/manifold/EdgeOverview";
import EgressLedger from "./components/manifold/EgressLedger";
import EdgeRobotDetail from "./components/manifold/EdgeRobotDetail";
import IntentPlanDetail from "./components/manifold/IntentPlanDetail";
import IntentPlans from "./components/manifold/IntentPlans";
import LedgerEventDetail from "./components/manifold/LedgerEventDetail";
import LedgerViewer from "./components/manifold/LedgerViewer";

function ProtectedLayout() {
  return (
    <div className="app-layout">
      <Sidebar />
      <main className="main-content">
        <ErrorBoundary>
        <Routes>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/projects/:id" element={<ProjectView />} />
          <Route path="/projects/:id/scan" element={<ScanUploader />} />
          <Route
            path="/projects/:id/environment/:envId"
            element={<EnvironmentViewer />}
          />
          <Route path="/projects/:id/training" element={<TrainingManager />} />
          <Route path="/projects/:id/deploy" element={<DeploymentView />} />
          <Route
            path="/projects/:id/deploy/:deploymentId/evidence"
            element={<Evidence />}
          />
          <Route path="/projects/:id/intent" element={<IntentPlans />} />
          <Route
            path="/projects/:id/intent/:planId"
            element={<IntentPlanDetail />}
          />
          <Route path="/projects/:id/edge" element={<EdgeOverview />} />
          <Route
            path="/projects/:id/edge/:robotId"
            element={<EdgeRobotDetail />}
          />
          <Route path="/projects/:id/rules" element={<RuleAuthor />} />
          <Route path="/projects/:id/egress" element={<EgressLedger />} />
          <Route path="/projects/:id/compliance" element={<LedgerViewer />} />
          <Route
            path="/projects/:id/compliance/:eventId"
            element={<LedgerEventDetail />}
          />
        </Routes>
        </ErrorBoundary>
      </main>
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<Landing />} />
      <Route path="/about" element={<About />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/maternal" element={<Maternal />} />
      <Route path="/aged-care" element={<AgedCare />} />
      <Route path="/robotwins" element={<RoboTwins />} />
      <Route path="/essentials" element={<Essentials />} />
      <Route path="/how-it-works" element={<HowItWorks />} />
      <Route path="/product/scan-to-sim" element={<ProductScanToSim />} />
      <Route
        path="/product/intelligence-core"
        element={<ProductIntelligenceCore />}
      />
      <Route path="/product/edge-reflex" element={<ProductEdgeReflex />} />
      <Route path="/product/local-mind" element={<ProductLocalMind />} />
      <Route path="/night-shift" element={<NightShift />} />
      <Route path="/compliance" element={<Compliance />} />
      <Route path="/contact" element={<Contact />} />
      {/* Authenticated app */}
      <Route
        path="/*"
        element={
          <AuthGate>
            <ProtectedLayout />
          </AuthGate>
        }
      />
    </Routes>
  );
}
